export default __webpack_public_path__ + "static/media/ic-star-fill.b9734c7b.svg";